import {Node, NodeName, NodeType} from "../../../model/Graph";
import {Rule} from "../rule-engine/configuration";
import {UiSchema} from "./ui-schema";

export interface DynamicBreadcrumbMetadata {
  data: string;
  label: Rule[] | string;
}

export interface DynamicSidebarMetadata {
  data: string;
  label?: string;
  icon?: string;
  hidden?: string;
}

export type ViewComponentType = 'auto' | 'state' | 'form' | 'table';

export type ViewComponent = string | { view: string, hidden: boolean, uiSchema?: UiSchema, type?: ViewComponentType}

export interface UiMetadata {
  $nodeName?: NodeName;
  $nodeType?: NodeType;
  service?: string;
  route?: string;
  parent?: string;
  routeParams?: string[];
  sidebar?: {label?: string ; icon?: string; hidden?: boolean; "hidden:expr"?: string; dynamic?: DynamicSidebarMetadata};
  breadcrumb?: string | DynamicBreadcrumbMetadata;
  tab?: {label?: string, group?: string, icon?: string};
  commands: string[];
  views: ViewComponent[];
}

export const getUiMetadata = (ui: Node): UiMetadata => {
  const uiMeta = ui.getParsedMetadata() as Record<string, any>;

  if(!uiMeta.commands) {
    uiMeta.commands = [];
  }

  if(!uiMeta.views) {
    uiMeta.views = [];
  }

  return uiMeta as UiMetadata;
}
